import { FC } from "react";
import bgImage from "../../Assets/homev2/dod-bg.png";
import image from "../../Assets/homev2/dod-image.png";
import { OutlineButton } from "./Buttons";
import ContainedButton from "./Buttons/Contained";

const DevelopmentOnDemand: FC = () => {
  return (
    <section
      className="w-full  bg-cover bg-no-repeat bg-bottom overflow-hidden max-h-[911px] relative"
      style={{
        backgroundImage: `url(${bgImage})`,
      }}
    >
      <div className="w-full h-full max-w-[1500px] mx-auto px-4 py-8 md:pt-20 flex flex-col justify-between items-center">
        <div>
          <h2 className="text-xl md:text-5xl lg:text-7xl text-white font-semibold text-center flex items-start justify-center">
            Development OnDemand
            <span className="text-xl md:text-3xl font-normal">&#8482;</span>
          </h2>
          <h4 className="text-center text-sm  text-white md:text-2xl mt-4">
            Engineering solutions. Built to scale.
          </h4>
          <div className="flex  max-w-[180px] items-center flex-col md:flex-row gap-4 md:gap-6 md:max-w-max md:w-max mx-auto  mb-14 md:mb-0 mt-4 md:mt-10">
            <a
              href="https://calendly.com/salesbox-meet/salesmrkt?month=2023-08"
              className="w-full "
            >
              <ContainedButton>Book a call</ContainedButton>
            </a>
            <a href="https://salesboxmarket.myshopify.com/" className="w-full ">
              <OutlineButton>Learn more</OutlineButton>
            </a>
          </div>
        </div>
        <div className="w-full lg:w-[65%]">
          <img
            src={image}
            alt="laptop"
            width="100%"
            height="100%"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default DevelopmentOnDemand;
